import { useState } from "react";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  return (
    <header className="main-header">
      {/* ===== Top Bar ===== */}
      <div className="topbar">
        <div className="topbar-left">
          <span>📞 +91 9443777668</span>
          <span>📞 +91 9944681772</span>
        </div>
        <div className="topbar-right">
          <span>📍 Sivapriya Nagar, Senthangudy, Mayiladuthurai</span>
        </div>
      </div>

      {/* ===== Navbar ===== */}
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo + Site Name */}
          <div className="logo">
            <img src="/logo.png" alt="Logo" className="logo-img" />
            <h1>Saisree Hardwares & Electricals</h1>
          </div>

          {/* Nav Menu */}
          <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>
            <li><a href="#home" onClick={() => scrollToSection("home")}>Home</a></li>
            <li><a href="#about" onClick={() => scrollToSection("about")}>About</a></li>
            <li><a href="#services" onClick={() => scrollToSection("services")}>Services</a></li>
            <li><a href="#gallery" onClick={() => scrollToSection("gallery")}>Gallery</a></li>
            <li><a href="#contact" onClick={() => scrollToSection("contact")}>Contact</a></li>
          </ul>

          {/* Enquire Button */}
          <button className="enquire-btn" href="#contact"onClick={() => scrollToSection("contact")}>
            Enquire
          </button>

          {/* Hamburger Icon */}
          <div
            className={`menu-toggle ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </header>
  );
}
